export const getDelivery = store => store.delivery.data
